import React from 'react';
import { createPortal } from 'react-dom';

/**
 * ModalPortal - Renders modal content using React Portal
 * 
 * This component ensures modals appear above all other content by rendering them
 * directly into the #modal-root div, bypassing the normal DOM hierarchy.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Modal content to render
 * @param {boolean} props.isOpen - Whether the modal is open/visible
 * 
 * @example
 * <ModalPortal isOpen={isModalOpen}>
 *   <div className="modal" onClick={() => setIsModalOpen(false)}>
 *     <div className="modal-content" onClick={(e) => e.stopPropagation()}>
 *       <h2>Modal Title</h2>
 *       <p>Modal content goes here</p>
 *     </div>
 *   </div>
 * </ModalPortal>
 */
const ModalPortal = ({ children, isOpen }) => {
  if (!isOpen) return null;

  const modalRoot = document.getElementById('modal-root');
  if (!modalRoot) {
    console.warn('Modal root element not found. Make sure #modal-root exists in index.html');
    return null;
  }

  return createPortal(children, modalRoot);
};

export default ModalPortal; 